import React, { useState, useEffect } from "react";
import BasicCustomTable from "../../../../component/basicTable";
import CustomPopupForm from "../../../../component/customPopupModel";
import axiosInstance from "../../../../configuration/request";
import { useSelector } from "react-redux";
import { useSnackbar } from "../../../../component/SnackbarContext";
import { customerColumns } from "../../../../constants/bussiness";

const CustomerManagement = () => {
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [customerData, setCustomerData] = useState([]);
  const { loginDetails } = useSelector((state) => state.counter);
  const storeId = loginDetails?.storeId;
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const showSnackbar = useSnackbar();
  const [filters, setFilters] = useState([]);

  useEffect(() => {
    fetchCustomers(page, rowsPerPage);
  }, [storeId, filters]);

  const buildParams = (pageNumber, limit) => {
    const params = {
      storeId: storeId,
      page: pageNumber ,
      limit,
    };

    filters.forEach(({ column, value }) => {
      if (column === "date" && value) {
        // const date = new Date(value);
        params.lastOrderDate = value
        // new Date(date.setHours(0, 0, 0, 0)).toISOString();
        // params.end_date = new Date(
        //   date.setHours(23, 59, 59, 999)
        // ).toISOString();
      } else if (column === "name" && value) {
        params.name = value.trim();
      } else if (column === "totalOrders" && value) {
        params.totalOrders = value.trim();
      }else if (column === "order_status") {
        if (value?.length) {
          params.tags = value.join(",");
        }
      }
    });

    return params;
  };

  const fetchCustomers = async (pageNumber = 1, limit = 10) => {
    const params = buildParams(pageNumber, limit);

    try {
      const response = await axiosInstance.get(
        `/customer/store/customer-management`, { params }
      );
      const formattedUser = response?.data?.data?.map((item) => ({
        id: item?.id,
        name: item?.name,
        phone_number: item?.phone_number,
        totalOrders: item?.totalOrders,
        date: item?.lastOrderDate,
        order_status: item?.tag,
      }));
      setCustomerData(formattedUser || []);
      setPage(Number(response?.data?.page ) || 0);
      setTotalCount(response?.data?.total || 0);
    } catch (error) {
      if (error?.response?.data?.message) {
        showSnackbar(error?.response?.data?.message, "error");
      } else {
        showSnackbar("Something went wrong!", "error");
      }
    }
  };

  const handlePageChangeRequest = (newPage, newRowsPerPage) => {
    setPage(newPage);
    setRowsPerPage(newRowsPerPage);
    fetchCustomers(newPage, newRowsPerPage);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleView = (row) => {
    setOpen(true);
    setSelectedRow(row);
  };

  const filterHandler = (filter) => {
    setFilters((prev) => {
      const filtered = prev.filter((f) => f.column !== filter.column);
      return [...filtered, filter];
    });
  };

  const handleTagChange = (newStatus, rowData) => {
    axiosInstance
      .patch(
        `/customer/users/customer-tag/${rowData?.id}?storeId=${storeId}&tag=${newStatus}`
      )
      .then(() => {
        fetchCustomers();
      })
      .catch((error) => {
        if (error?.response?.data?.message) {
          showSnackbar(error?.response?.data?.message, "error");
        } else {
          showSnackbar("Something went wrong!", "error");
        }
      });
  };

  return (
    <div className="pl-6 pr-4">
      <h2 className="text-2xl font-semibold mb-2 mt-1 ml-3">
        Customer Management
      </h2>
      <div className="px-2 pt-1 pb-4 h-[calc(100vh-145px)]">
        <BasicCustomTable
          columns={customerColumns}
          rows={customerData}
          onView={handleView}
          colorHeader={true}
          customClassHeader="table-header-cell-colored"
          tableName="customer management"
          handleFilter={filterHandler}
          maxHeightClass="max-h-[calc(100vh-230px)]"
          backendPagination={true}
          totalCount={totalCount}
          onPageChangeRequest={handlePageChangeRequest}
          pageLimit={rowsPerPage}
          page={page}
          onTagChange={handleTagChange}
        />
      </div>

      <CustomPopupForm
        isOpen={open}
        handleClose={handleClose}
        dialogType="customer-view"
        dialogDetails={selectedRow}
      />
    </div>
  );
};

export default CustomerManagement;
